import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import Text from '../Text'
import CloseIcon from '../Icons/CloseIcon'
import classNames from 'classnames'

const BottomSheet = ({
  show = false,
  title,
  children,
  onClose = () => {},
  closeIcon = <CloseIcon />,
  headerClassName = '',
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [show])

  if (!show) return null

  const handleClose = () => {
    onClose()
    document.body.style.overflow = 'auto'
  }

  return createPortal(
    <div className="fixed inset-0 z-[100]">
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={handleClose}
      />
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-lg">
        <div
          className={classNames(
            'flex justify-between items-center px-5 py-4 border-b border-gray-200',
            headerClassName,
          )}
        >
          {title ? (
            <Text variant="title" size="medium" tag="p" className="capitalize">
              {title}
            </Text>
          ) : null}
          <button className="text-gray-500 p-2 -mr-1" onClick={handleClose}>
            {closeIcon}
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body,
  )
}

export default BottomSheet
